import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
import { useParams } from 'react-router-dom';
// components
import { useSettingsContext } from 'src/components/settings';
import { RoleBasedGuard } from 'src/auth/guard';
//
import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';
import { useDispatch } from 'react-redux';
// redux for access
import { resetAccessRights } from 'src/redux/slices/access';
//permissions
import {permissions} from 'src/assets/data/permissions';
import { getPermissions } from 'src/redux/slices/access';
// ----------------------------------------------------------------------
const buildPathName = (params, path)=>{
  const queryP = Object.keys(params);
  for(var q=0; q<queryP.length;q++){
    path = path.replace(`:${queryP[q]}`,params[queryP[q]])
  }
  return path;
}
export default function DashboardLayout({ children }) {
  
  const location = useLocation();
  const params = useParams();
  
  const dispatch = useDispatch();
  dispatch(resetAccessRights());

  const filter =  permissions.filter(
                    p=> buildPathName(params,p.path) == location.pathname
                  );

  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  useEffect(()=>{
    if(filter.length>0){
      const {permissionType, permissionName} = filter[0];
      dispatch(getPermissions(permissionName, permissionType));
    }
  },[filter, dispatch])
  
  if (isHorizontal) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        {lgUp ? renderHorizontal : renderNavVertical}

        <Main>
          <RoleBasedGuard>
            {children}
          </RoleBasedGuard>
        </Main>
      </>
    );
  }

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}

          <Main>
            <RoleBasedGuard>
              {children}
            </RoleBasedGuard>
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <RoleBasedGuard>
            {children}
          </RoleBasedGuard>
        </Main>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
